module.exports = __webpack_public_path__ + "static/img/u276.350c47b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zyImages/u276.jpeg
// module id = 367
// module chunks = 68